/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MathFunctionOffIcon16Light } from './MathFunctionOffIcon16Light';
import { MathFunctionOffIcon16Regular } from './MathFunctionOffIcon16Regular';
import { MathFunctionOffIcon16Solid } from './MathFunctionOffIcon16Solid';
import { MathFunctionOffIcon20Light } from './MathFunctionOffIcon20Light';
import { MathFunctionOffIcon20Regular } from './MathFunctionOffIcon20Regular';
import { MathFunctionOffIcon20Solid } from './MathFunctionOffIcon20Solid';
import { MathFunctionOffIcon24Regular } from './MathFunctionOffIcon24Regular';
import { MathFunctionOffIcon24Solid } from './MathFunctionOffIcon24Solid';
import { MathFunctionOffIcon32Regular } from './MathFunctionOffIcon32Regular';
import { MathFunctionOffIcon64Regular } from './MathFunctionOffIcon64Regular';
var sizes = {
    16: {
        light: MathFunctionOffIcon16Light,
        regular: MathFunctionOffIcon16Regular,
        solid: MathFunctionOffIcon16Solid,
    },
    20: {
        light: MathFunctionOffIcon20Light,
        regular: MathFunctionOffIcon20Regular,
        solid: MathFunctionOffIcon20Solid,
    },
    24: {
        regular: MathFunctionOffIcon24Regular,
        solid: MathFunctionOffIcon24Solid,
    },
    32: {
        regular: MathFunctionOffIcon32Regular,
    },
    64: {
        regular: MathFunctionOffIcon64Regular,
    },
};
export var MathFunctionOffIcon = forwardRef('MathFunctionOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
